export const TOKEN = "MEDHUB_TOKEN";
export const EXP = "MEDHUB_EXP_TOKEN";
export const REFRESH_TOKEN = "MEDHUB_REFRESH_TOKEN";
export const ROLE = "MEDHUB_USER_ROLE";
export const SNACK_BAR = "MEDHUB_SNACK_BAR";
